import React, { useState } from "react";
import api from '../..//services/api';
import { Button, Form, FormGroup, FormControl, FormLabel } from "react-bootstrap";
import "./TrocaSenha.css";
import history from '../history';
import Menu from '../menu/Menu';
import Cookies from 'universal-cookie';


export default function TrocaSenha() {
    
    const cookies = new Cookies();

    const CPF = cookies.get('ckCPF');

    const [SenhaAtual, setSenhaAtual] = useState('');
    const [NovaSenha, setNovaSenha] = useState('');

    let vSenha = '';
       
    function validateForm() {
        return SenhaAtual.length > 0 && NovaSenha.length > 0;
    }

    function validaSenhaNova() { 
        console.log(vSenha[0], NovaSenha)

        if (vSenha[0] === NovaSenha) {
            alert('Nova senha atualizada ... ')
            history.push('/HOn/Home')                   
        }
        
    }

    async function handleSubmit(event) {

        event.preventDefault();
        
        const resp = await api.get(`/datasnap/rest/tsm/AltSenha("${CPF}","${SenhaAtual}","${NovaSenha}")`)
            
        cookies.set('ckSenha', resp.data.result[0].map(usua => usua.SENHA), { path: '/' })

        vSenha = cookies.get('ckSenha')

        if (vSenha[0] === '') {
            alert('Algo de errado !!!')
        } else {
            validaSenhaNova()
        }
        
    }

    return (
        <div className="ListPed">
            <Menu />
            <div className="container">
                
                <Form onSubmit={handleSubmit}>
                    <h2>HOn-TROCAR SENHA</h2>
                    <FormGroup controlId="email"> 
                        <FormLabel>Senha Atual</FormLabel>
                        <FormControl
                            autoFocus
                            type="password"
                            value={SenhaAtual}
                            onChange={e => setSenhaAtual(e.target.value)}
                        />
                    </FormGroup>
                    <FormGroup controlId="NovaSenha">
                        <FormLabel>Nova Senha</FormLabel>
                        <FormControl
                            value={NovaSenha}
                            onChange={e => setNovaSenha(e.target.value)}
                            type="password"
                        />
                    </FormGroup>
                    <Button block disabled={!validateForm()} type="submit">
                        Trocar Senha
                </Button>
                </Form>
            </div>
        </div>
    );
}